import { useSnackbar } from 'notistack';
import { useQueryClient, useMutation } from 'react-query';
import { useProgress } from 'shared/hooks';
import { useService } from 'shared/providers';
import { UploadProductsProps } from 'shared/services';

export function useProductUpload() {
    const { productService } = useService();
    const queryClient = useQueryClient();
    const [progress, setTotal, incrementProgress] = useProgress();
    const { enqueueSnackbar } = useSnackbar();
    const mutation = useMutation<string, Error, UploadProductsProps>(
        request => productService.uploadProducts(request),
        {
            onSuccess: message => {
                enqueueSnackbar(message, { variant: 'success' });
                queryClient.invalidateQueries('products');
            },
        }
    );

    return { mutation, progress, setTotal, incrementProgress } as const;
}
